<template>
	<div :class="{'has-error': mensagemErro}">
		<label> <span v-if="obrigatorio" class="no-print">*</span> {{ label }}: </label>
		<money
			:value="value.model"
			:placeholder="placeholder"
			:disabled="disabled"
			@input="(value) => emitValue('input', value)"
			@change="(value) => emitValue('change', value)"
			v-bind="_vpercem(casas)"
			class="form-control text-right input-sm"
		></money>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
import mixinInputModel from './mixinInputModel'
export default {
	mixins: [mixinInputModel],
	props: {
		casas: {
			type: Number,
			default: 2
		}
	}
}
</script>
